module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1e975e828fa86a4b68f0c362c22207f3.png";